<script setup>
import { Head, Link } from "@inertiajs/vue3";
import VHeaderButtonEdit from "@/Shared/HeaderButton/VButtonEdit.vue";
import VHeaderBreadcrumb from "@/Shared/VHeaderBreadcrumb.vue";
import VInputReadonlyWithLabel from "@/Shared/Form/VInputReadonlyWithLabel.vue";
import VDevider from "@/Shared/VDevider.vue";
import VModalForm from "./_partials/VModalForm.vue";
import { ref } from "vue";

defineProps({
    user: Object,
    roles: Array,
    filters: Object,
    canEdit: Boolean,
    urlUpdate: String,
    urlUpdateCreds: String,
    urlIndex: String,
});

const breadcrumbs = [
    {
        url: "#",
        label: "My Profile",
    },
];

const isShowForm = ref(false);

const closeForm = () => {
    isShowForm.value = false;
};

const onSave = () => {
    isShowForm.value = false;
};
</script>

<template>
    <Head>
        <title>My Profile</title>
    </Head>

    <div class="p-3">
        <VHeaderBreadcrumb :breadcrumbs="breadcrumbs" />

        <div class="card mb-3">
            <div class="card-body">
                <div class="d-flex justify-content-between">
                    <h5>My Profile</h5>
                    <div class="btn-wrapper">
                        <VHeaderButtonEdit @onClick="isShowForm = true" />
                    </div>
                </div>
                <VDevider />

                <div class="row">
                    <div class="col-lg-6">
                        <VInputReadonlyWithLabel
                            label="Name"
                            :value="user.name"
                        />
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6">
                        <VInputReadonlyWithLabel
                            label="Roles"
                            :value="
                                user.roles?.map((item) => item.name).join(',')
                            "
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-lg-6">
                        <VInputReadonlyWithLabel
                            label="Status"
                            :value="user.status_text"
                        />
                    </div>
                </div>
                <VDevider class="my-4" />

                <div class="row">
                    <div class="col-lg-6 mb-3">
                        <VInputReadonlyWithLabel
                            label="Email"
                            :value="user.email"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>

    <VModalForm
        v-if="isShowForm"
        :user="user"
        :roles="roles"
        :urlSubmit="urlUpdate"
        :urlUpdateCreds="urlUpdateCreds"
        method="put"
        @onSave="onSave"
        @onCancel="closeForm"
    />
</template>
